import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import FrostHistoryPage from "@/pages/FrostHistoryPage";
import HomePage from "@/pages/HomePage";
import StationsPage from "@/pages/StationsPage";
import StationDetailPage from "@/pages/StationDetailPage";
import RainfallPage from "@/pages/RainfallPage";
import SprayPage from "@/pages/SprayPage";
import FirePage from "@/pages/FirePage";
import HistoryPage from "@/pages/HistoryPage";
import MapPage from "@/pages/MapPage";
import SettingsPage from "@/pages/SettingsPage";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/stations" element={<StationsPage />} />
                    <Route path="/stations/:id" element={<StationDetailPage />} />
                    <Route path="/rainfall" element={<RainfallPage />} />
                    <Route path="/spray" element={<SprayPage />} />
                    <Route path="/fire" element={<FirePage />} />
                    <Route path="/history" element={<HistoryPage />} />
                    <Route path="/frost-history" element={<FrostHistoryPage />} />
                    <Route path="/map" element={<MapPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                </Routes>
            </Layout>
            <Toaster position="top-right" />
        </BrowserRouter>
    );
}

export default App;
